import { floatParser } from "shared/components/forms/BaseInput/parsers";

export const salePriceParser = floatParser({ maxDecimals: 2 });
export const purchasePriceParser = floatParser({ maxDecimals: 2 });

// AppFolio-sourced fee inputs operate in integer cents. $10,000 cap mirrors
// the Listing-template fee inputs (MAX_FEE_CENTS).
export const APPFOLIO_FEE_MAX_CENTS = 1_000_000;

export const RENT_PMS_SYNCED = `Rent amount is synchronized with PMS. You can manually edit
  the field by disabling synchronization for this field. To do
  this, click 'Edit manually' option`;

export const RENT_PMS_UNSYNCED = `Rent amount is currently edited manually. You can enable
synchronization by clicking 'Sync with PMS' option`;

export const SALE_PRICE_PMS_SYNCED = `Sale price is synchronized with PMS. You can manually edit
  the field by disabling synchronization for this field. To do
  this, click 'Edit manually' option`;

export const SALE_PRICE_PMS_UNSYNCED = `Sale price is currently edited manually. You can enable
synchronization by clicking 'Sync with PMS' option`;

export const PURCHASE_PRICE_PMS_SYNCED = `Purchase price is synchronized with PMS. You can manually edit
  the field by disabling synchronization for this field. To do
  this, click 'Edit manually' option`;

export const PURCHASE_PRICE_PMS_UNSYNCED = `Purchase price is currently edited manually. You can enable
synchronization by clicking 'Sync with PMS' option`;

export const ALLOW_APPLICATIONS_PMS_SYNCED = `Allow applications is synchronized with PMS. You can manually edit
  the field by disabling synchronization for this field. To do
  this, click 'Edit manually' option`;

export const LISTED_PMS_SYNCED = `Listing status is synchronized with PMS. You can manually edit
  the field by disabling synchronization for this field. To do
  this, click 'Edit manually' option`;

export const ALLOW_APPLICATIONS_LOCKED_BY_LISTED = `To disallow applications, turn off the 'List on' toggle first`;

export const LISTED_REQUIRES_APPLICATIONS = `Listing requires applications to be allowed. Applications are
turned off by PMS sync — switch them to 'Edit manually' and enable first`;
